import constants from '#packages/constants';
import type { EditorAPI } from '#packages/editorAPI';
import { HttpClient } from '@wix/http-client';
import {
  AI_GATEWAY_APP_DEF_FOR_GET_PROMPTS,
  PROMPT_HUB_PROMPTS_ID,
  PromptParams,
} from './consts';
import type {
  AiHtmlGenerationPromptParams,
  AiHtmlGenerationPromptResponse,
} from './types';

const getMetaSiteInstance = (editorAPI: EditorAPI) => {
  return editorAPI.dsRead.platform.getAppDataByApplicationId(
    constants.APPLICATIONS.META_SITE_APPLICATION_ID,
  )?.instance;
};

export async function generateHtmlPrompt(
  params: AiHtmlGenerationPromptParams,
  editorAPI: EditorAPI,
  featureName?: string,
): Promise<string> {
  const httpClient = new HttpClient({
    headers: { Authorization: getMetaSiteInstance(editorAPI) },
  });
  const {
    userInstruction,
    allowedComponents,
    businessName,
    businessType,
    toneOfVoice,
  } = params;

  const requestBody = {
    appDefId: AI_GATEWAY_APP_DEF_FOR_GET_PROMPTS,
    promptId: PROMPT_HUB_PROMPTS_ID.SECTION_GENERATION,
    params: {
      [PromptParams.USER_INSTRUCTION]: userInstruction,
      [PromptParams.ALLOWED_COMPONENTS]: allowedComponents,
      [PromptParams.BUSINESS_TYPE]: businessType,
      [PromptParams.BUSINESS_NAME]: businessName,
      [PromptParams.TONE_OF_VOICE]: toneOfVoice,
    },
    userRequestInfo: {
      additionalTags: 'generate_ai_html_section_prompt',
      featureName,
    },
  };
  const { data } = await httpClient.post<AiHtmlGenerationPromptResponse>(
    '/_serverless/ai-gateway/ai-prompt',
    requestBody,
  );
  return data.response.generatedTexts[0];
}
